module.exports = __webpack_public_path__ + "static/media/instagram-brands.05bb6d2f.svg";